import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

/**
 * Global page loader API used by auth flows.
 * Drives `<app-loading-state>` hosted in `AppComponent` (same pattern as AppToastService).
 */
@Injectable({ providedIn: 'root' })
export class AppLoaderService {
  private visibleCount = 0;
  private readonly visibleSubject = new BehaviorSubject<boolean>(false);
  readonly visible$ = this.visibleSubject.asObservable();

  showLoader(_theme: 'light' | 'dark' | string = 'dark', mills?: number): void {
    this.visibleCount += 1;
    this.visibleSubject.next(true);

    if (mills != null && mills > 0) {
      window.setTimeout(() => this.hide(), mills);
    }
  }

  hide(): void {
    this.visibleCount = Math.max(0, this.visibleCount - 1);
    if (this.visibleCount === 0) {
      this.visibleSubject.next(false);
    }
  }
}
